import CustomButton from './CustomButton';

export default CustomButton;